import { useEffect, useState } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
/**
 * Hook used with Overlay that updates the Popper state on the first render and when the target element changes.
 *
 * @param {MutableRefObject<UsePopperState | null>} popperRef - The mutable ref object that holds the Popper state.
 * @param {UsePopperOptions | null} popperConfig - The Popper configuration options.
 * @param {any} target - The target element for the Popper.
 * @param {boolean} show - Whether the overlay is shown or not
 * @returns {UsePopperOptions} - An amended popper-configuration used to catch the first popper-update.
 */ export const useUpdatePopper = (popperRef, popperConfig, target, show)=>{
    const [hasRendered, setHasRendered] = useState(false);
    const onFirstUpdate = useEventCallback((state)=>{
        setHasRendered(true);
        popperConfig?.onFirstUpdate?.(state);
    });
    const amendedPopperConfig = {
        ...popperConfig ?? {},
        onFirstUpdate
    };
    useEffect(()=>{
        if (!show) {
            setHasRendered(false);
        }
    }, [
        show
    ]);
    useEffect(()=>{
        if (hasRendered && target) {
            popperRef.current?.update?.();
        }
    }, [
        hasRendered,
        target
    ]);
    return amendedPopperConfig;
};
